module.exports = {
  purge: {
    enabled: true,
    content: ["./src/**/*.tsx"],
    css: ["./src/**/*.css"],
    options: {
      whitelist: ['html'],
      whitelistPatterns: [
        /--i--/,
        /xs:w-/,
        /sm:w-/,
        /md:w-/,
        /lg:w-/,
        /xl:w-/,
        /order-/,
        /input:focus/
      ],
    },
    defaultExtractor: content => content.match(/[\w-/:]+(?<!:)/g) || []
  },
  theme: {
    colors: {
      // PRIMARY COLORS
      blue900: "#152e5f",
      blue700: "#1b4c8d",
      blue500: "#2071bd",
      blue400: "#3399e1",
      blue200: "#d8ecfa",
      blue100: "#edf5fc",

      // ACCENTS
      green: "#a9cc38",
      green700: "#2b7e52",

      // GRAYSCALE
      grey900: "#1a202c",
      grey700: "#4a5468",
      grey500: "#a0aec0",
      grey300: "#e2e8f0",
      grey100: "#f5f8fA",
      white: "#fff",

      // UTILITIES
      success: "#2b7e52",
      error: "#c53030",
      red700: "#c53030",
      errorHover: "#e53e3e",
      errorActive: "#882b2b",
      transparent: "transparent",
      yellow700: "#f7b500",

      // TINTS
      tintGreen: "rgba(40, 167, 69, 0.25)",
      tintRed: "rgba(208, 2, 27, 0.25)",
    },
    fontFamily: {
      body: ["myriad-pro", "sans-serif"],
      mono: [
        "Menlo",
        "Monaco",
        "Consolas",
        "Liberation Mono",
        "Courier New",
        "monospace"
      ]
    },
    screens: {
      'xs': '320px',
      'sm': '640px',
      'md': '768px',
      'lg': '1024px',
      'xl': '1280px'
    }
  },
  variants: {}
};
